import { React, useState, useEffect } from "react";

const PopUpSuperOvert20Results = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let superOverRunners = [];
    let superOverWinners = [];

    let team1Cards = [];
    let team2Cards = [];

    if (marketType == 58) {

        superOverRunners = [
            resultData.rnr1,
            resultData.rnr2,
            resultData.rnr3,
            resultData.rnr4,
            resultData.rnr5,
            resultData.rnr6,
        ].filter(Boolean);

        superOverWinners = resultData.resultTxt
            ? resultData.resultTxt.split(",").map(item => item.trim())
            : [];

        team1Cards = resultData.c1 ? resultData.c1.split(",") : [];
        team2Cards = resultData.c2 ? resultData.c2.split(",") : [];
    }


    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="super-over" style={{ display: marketType == 58 ? "" : "none" }}>
                        <div className="left-content">
                            <div className="card">

                                <div className="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>

                                <div className="card-body">
                                    <div className="player-item">

                                        <b>
                                            <span className="name" style={{ color: "#000" }}>{resultData.rnr1}</span>
                                        </b>

                                        <div className="player-card">

                                            <div className="BFBCardHandViewDealerab">

                                                <div
                                                    className="BFBCardFanViewab"
                                                    style={{
                                                        justifyContent: "flex-start",
                                                        padding: "2px"
                                                    }}
                                                >

                                                    {team1Cards.map((card, index) => (
                                                        <div className="RSMImageView2ab" key={index}>
                                                            <img
                                                                src={`/assets/images/cards/${card}.svg`}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "55px",
                                                                    height: "auto"
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="player-item">

                                        <b>
                                            <span className="name" style={{ color: "#000" }}>{resultData.rnr2}</span>
                                        </b>

                                        <div className="player-card">

                                            <div className="BFBCardHandViewDealerab">

                                                <div
                                                    className="BFBCardFanViewab"
                                                    style={{
                                                        justifyContent: "flex-start",
                                                        padding: "8px"
                                                    }}
                                                >

                                                    {team2Cards.map((card, index) => (
                                                        <div className="RSMImageView2ab" key={index}>
                                                            <img
                                                                src={`/assets/images/cards/${card}.svg`}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "55px",
                                                                    height: "auto"
                                                                }}
                                                            />
                                                        </div>
                                                    ))}

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                    <div style={{ marginTop: "35px" }}>

                                        {superOverRunners.map((runner, index) => {

                                            let winner = false;

                                            if (index <= 1) {
                                                winner = runner === superOverWinners[0];
                                            } else if (index <= 3) {
                                                winner = runner === superOverWinners[1];
                                            } else {
                                                winner = runner === superOverWinners[2];
                                            }

                                            return (

                                                <div
                                                    key={index}
                                                    style={{
                                                        textAlign: "center",
                                                        marginBottom: "18px"
                                                    }}
                                                >

                                                    <div
                                                        style={{
                                                            fontSize: "22px",
                                                            fontWeight: "700"
                                                        }}
                                                    >
                                                        {runner}
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: "15px",
                                                            marginTop: "4px",
                                                            color: "#000",
                                                            textTransform: "uppercase"
                                                        }}
                                                    >
                                                        {winner ? "WINNER" : "LOSER"}
                                                    </div>

                                                </div>

                                            );

                                        })}

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PopUpSuperOvert20Results;

